import React from 'react';
import styles from '../static/styles/PremiumPackagePopup.module.css';
import kingLogo from '../static/img/premiumPackage/premiumIcon.png';
import { useNavigate } from "react-router-dom";
import { trackPremiumBenefitsClick, trackPremiumPopupClose } from '../utils/analytics';
import challengeImage from '../static/img/Sidebar/iconDailyTasks.svg';
import tournamentImage from '../static/img/Sidebar/iconTournaments.png';
import rewardsImage from '../static/img/Sidebar/iconRewards.svg';


const PremiumPackagePopup = ({ isOpen, onClose }) => {
    const navigate = useNavigate();

    const handleClose = (reason) => {
        trackPremiumPopupClose(reason);
        onClose();
    };

    const handleBenefitsClick = () => {
        trackPremiumBenefitsClick();
        navigate("/premium-plan");
    };

    if (!isOpen) return null;

    return (
        <div className={styles.popupOverlay} onClick={() => handleClose('overlay')}>
            <div className={styles.popupContent} onClick={(e) => e.stopPropagation()}>
                <div className={styles.coinsContainer}>
                    <img
                        src={kingLogo}
                        alt="Premium"
                        className={styles.coinsImage}
                    />
                </div>
                <h2 className={styles.title}>
                    UNLOCK PREMIUM!
                </h2>
                <h2 className={styles.subtitle}>
                    Subscribe to ESL Premium and unlock
                    exclusive features, tournaments and rewards.
                </h2>

                <div className={styles.premiumList}>
                    <div className={styles.premiumManu}>
                        <img src={challengeImage} alt="❎" />
                        <h2>1.2x Credits Multiplier</h2>
                    </div>
                    <div className={styles.premiumManu}>
                        <img src={tournamentImage} alt="🏆" />
                        <h2>Free Tournament Entry</h2>
                    </div>
                    <div className={styles.premiumManu}>
                        <img src={rewardsImage} alt="🎁" />
                        <h2>Premium Gift shop access</h2>
                    </div>
                    <div className={styles.premiumManu}>
                        <img src={challengeImage} alt="♾️" />
                        <h2>Unlimited Challenges </h2>
                    </div>
                </div>

<button className={styles.rewardButton} onClick={handleBenefitsClick}> 
                    <span>SEE PREMIUM BENEFITS</span>
                </button>

                <p className={styles.maybeLater} onClick={() => handleClose('maybe_later')}>
                    Maybe later
                </p>

            </div>
        </div>
    );
};

export default PremiumPackagePopup;